<template>
  <div id="app">
    <!-- Top navigation bar -->
    <navbar v-if="userLoggedIn.category" :key="navbarKey"/>
    <notification-bubble v-if="showNotificationBubble && userLoggedIn" ref="notificationBubble" />
    <div class="d-flex justify-content-center position-fixed w-100" style="z-index: 1; margin-top: -15px">
      <div v-if="getIsPlatformClosed && $route.meta.style !== 'login'" class="alert bg-tertiary text-white mx-auto shadow " role="alert">
        <i class="fas fa-info-circle mr-2"></i>Offers and Negotiations are currently disabled across the platform. You can still view Orders, Reports and other pages on the platform.
      </div>
    </div>
    <div 
      class="container-fluid"
      :class="{'general-container' : $route.meta.style !== 'login', 'px-0' : $breakpoint.lgAndDown}"
    >     
      <router-view name="TermsAndConditions"></router-view>
      <router-view name="MyAccount"></router-view>
      
      <router-view v-if="userLoggedIn.category ==='buyer'" name="buyerDashboard"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="AllPrices"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="NegotiationsBuyer"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="ExistingContracts"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="OlfChat"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="PurchaseHistory"></router-view>
      <router-view v-if="userLoggedIn.category ==='buyer'" name="MySuppliers"></router-view>

        <!-- <notification-panel class="notification-panel-container"/>
        <notification-panel-icon class="notification-panel-icon"/> -->
      
      <router-view v-if="userLoggedIn.category === 'seller'" name="sellerDashboard"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="manageProducts"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="NegotiationsSeller"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="OlfChat"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="MyCustomers"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="PurchaseHistory"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="OrderCapture"></router-view>
      <router-view v-if="userLoggedIn.category === 'seller'" name="PricingEngine"></router-view>

      <action-confirmation v-if="showActionConfirmation && userLoggedIn" ref="actionConfirmation" />

    </div>

    <help-panel v-if="userLoggedIn.category" ref="helpPanel" />

    <start-conversation v-if="searchModal" ref="startConversation"/>
        
    <offer-modal v-if="showSpotModal || showContractModal" ref="offerModal" />

    <confirmation-remove-item v-if="showItemRemovalConfirmation" ref="confirmationRemoveItem"
      :itemToRemove="itemToRemove" :itemType="itemToRemoveType" />
    
    <upload-matrix v-if="showUploadMatrix" ref="uploadMatrix"/>

    <!-- Decide whether to show Daily Settlement/Global Pricing Rules -->
    <template v-if="showDailyPriceModal && userLoggedIn">
      <pricing-rules-daily-prices v-if="isPricingEngineEnabled" ref="dailyPrices" />
      <legacy-daily-prices v-else ref="dailyPrices"/>
    </template>

    <select-favourites v-if="selectFavouritesModal" ref="selectFavourites" />

    <start-negotiation v-if="showStartNegotiation" ref="startNegotiation" />
    <renegotiate-buyer v-if="showRenegotiateModal" ref="renegotiateBuyer" />
    <accept-counter-offer v-if="showAcceptCounterOffer" ref="acceptCounterOffer" />
    <accept-negotiation v-if="showAcceptNegotiation" ref="acceptNegotiation" />
    <negotiation-unavailable v-if="negotiationUnavailableWindowShown" ref="negotiationUnavailable" />

    <confirmation-logout v-if="showConfirmationLogout" ref="confirmationLogout"/>
    <confirmation-remove-favourite v-if="showConfirmationRemoveFavourite" ref="confirmationRemoveFavourite" />

    <router-view name="login"></router-view>
    <router-view name="requestNewPassword"></router-view>
    <router-view name="resetPassword"></router-view>
    <router-view name="logoutSuccessful"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import Navbar from "@/components/Navigation/Navbar.vue";
import NotificationPanel from "@/components/NotificationsTool/NotificationPanel.vue";
import NotificationPanelIcon from "@/components/NotificationsTool/NotificationPanelIcon.vue";
import NotificationBubble from '@/components/NotificationsTool/NotificationBubble.vue'
import ActionConfirmation from '@/components/NotificationsTool/ActionConfirmation.vue'

/* Modals */
import OfferModal from "@/modals/OfferModal.vue";
import ConfirmationLogout from "@/modals/ConfirmationLogout.vue";
import SelectFavourites from "@/modals/SelectFavourites.vue";
import StartConversation from "@/components/ChatService/StartConversation.vue";
import StartNegotiation from"@/modals/StartNegotiation.vue";
import PricingRulesDailyPrices from "@/modals/DailyPrices/PricingRulesDailyPrices.vue";
import LegacyDailyPrices from "@/modals/DailyPrices/LegacyDailyPrices.vue";
import RenegotiateBuyer from "@/modals/RenegotiateBuyer.vue";
import AcceptCounterOffer from "@/modals/AcceptCounterOffer.vue";
import AcceptNegotiation from "@/modals/AcceptNegotiation.vue";
import UploadMatrix from "@/modals/UploadMatrix.vue";
import ConfirmationRemoveFavourite from '@/modals/ConfirmationRemoveFavourite.vue';
import ConfirmationRemoveItem from '@/modals/ConfirmationRemoveItem.vue';
import NegotiationUnavailable from '@/modals/NegotiationUnavailable.vue';
import HelpPanel from '@/components/HelpPanel.vue';

import breakpoint from '@/mixins/index';

export default {
  mixins: [breakpoint],
  components: {
    Navbar,
    StartConversation,
    NotificationPanel,
    NotificationPanelIcon,
    ConfirmationLogout,
    SelectFavourites,
    StartNegotiation,
    PricingRulesDailyPrices,
    LegacyDailyPrices,
    RenegotiateBuyer,
    AcceptCounterOffer,
    AcceptNegotiation,
    UploadMatrix,
    ConfirmationRemoveFavourite,
    NotificationBubble,
    OfferModal,
    ActionConfirmation,
    ConfirmationRemoveItem,
    NegotiationUnavailable,
    HelpPanel,
  },
  data() {
    return {
      showSidemenu: true,
      navbarKey: 0,
    };
  },
  computed: {
    ...mapGetters('buyerOpen', ['getIsPlatformClosed']),
    ...mapGetters("login", ["isPricingEngineEnabled"]),
    ...mapState('itemRemoval', ['showItemRemovalConfirmation', 'itemToRemove', 'itemToRemoveType']),
    ...mapState("conversation", ['searchModal']),
    ...mapState("login", ["userLoggedIn", 'showConfirmationLogout']),
    ...mapState('negotiation', ['showStartNegotiation' ,'showRenegotiateModal', 'showAcceptCounterOffer', 'showAcceptNegotiation',
      'negotiationUnavailableWindowShown']),
    ...mapState('notifications', ['showNotificationBubble', 'showActionConfirmation']),
    ...mapState('sellerOffers',['showSpotModal','showContractModal', 'showUploadMatrix']),
    ...mapState("selectFavourites", ["selectFavouritesModal",'showConfirmationRemoveFavourite']),
    ...mapState('livePrices',['showDailyPriceModal']),
    displayNotificationBubble: function(){
      if (this.showNotificationBubble){
        setTimeout(() => {
          $('.notification-toast').toast('show')
        }, 1000)
      }
    },
    openModals(){
      if(this.showDailyPriceModal){
        setTimeout(()=>{
          const element = this.$root.$refs.dailyPrices.$el
          $(element).modal({backdrop: 'static', keyboard: false})
        },500)
      }
      return
    },
  },
  watch: {
    displayNotificationBubble(){},
    openModals(){},
  },
  methods: {
    ...mapActions("conversation", ["showSearchModal"]),
    ...mapActions("fuelsType",["getFuelsList"]),
    ...mapActions('terminals', ['getTerminals']),
  },
}
</script>
